<template>
  <div class="page">
    <div class="main">
      <div class="login">验证登录</div>
      <div class="ph-input">
        <van-field v-model="iccid" type="tel" clear-trigger="always" readonly class="ph-t ph-t-icon" />
      </div>
      <br />
      <div class="ph-input" style="margin-top:0px;">
        <van-field v-model="userPhone" type="tel" clear-trigger="always" class="ph-t ph-t-icon1" clearable
          placeholder="绑定手机号" />
      </div>
    </div>
    <van-button class="bu_tn-a" round block type="info" native-type="submit" @click="onSubmit">验 证</van-button>
    <div class="prompt" :style="{ 'margin-top': height + 'px' }">
      <div class="prompt-top">温馨提示</div>
      <div class="prompt-name">1、为了您的设备安全，请输入您绑定的设备号。</div>
    </div>
  </div>
</template>
<script>
import { wxRequest } from '@/api/user'
import { Toast } from 'vant'
export default {
  components: {
  },
  data() {
    return {
      verifiedInfo: {
        iccid: localStorage.getItem('iccid'),
        name: '张三',
        userPhone: '',
        idcard: '411529199920206952',
        smsCode: '',
        isFirst: 0,
      },
      userPhone: localStorage.getItem('myCheckoutPhone'),
      smsCode: '',
      countdown: false,
      height: null,
      timer: null,
      count: null,
      isNewPage: localStorage.getItem('isNewPage'),
      iccid: localStorage.getItem('recordLoginText'),
    }
  },
  watch: {

  },
  mounted() {
    this.height = document.documentElement.clientHeight - 610
  },
  methods: {
    getCode() {
      if (!(/^[1][3,4,5,6,7,8,9][0-9]{9}$/.test(this.userPhone))) {
        Toast.fail('请填写正确的手机号')
        return
      }
      wxRequest('/bindPhone/sms/code', { userPhone: this.userPhone }, 'post').then(res => {
        if (res.data.code === '200') {
          const TIME_COUNT = 59
          if (!this.timer) {
            this.count = TIME_COUNT
            this.countdown = false
            this.timer = setInterval(() => {
              if (this.count > 0) {
                this.count--
                this.countdown = true
              } else {
                this.countdown = false
                clearInterval(this.timer)
                this.timer = null
              }
            }, 1000)
          }
          Toast.success('发送成功')
        } else {
          Toast.fail(res.data.message)
        }
      })
    },
    onSubmit() {
      wxRequest("sim/detail", { iccid: this.iccid, userPhone: this.userPhone, sheMgr: 'yes' }, "post").then((res) => {
        if (res.data.code === '200') {
          localStorage.setItem('myCheckoutPhone',this.userPhone)
          var isNewPage = localStorage.getItem('isNewPage');
          if (isNewPage == 0) {
            this.$router.replace('/user/home');
          } else {
            this.$router.replace('/userNew/home');
          }
        } else {
          Toast.fail(res.data.message);
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  background: #F7F8FA url('../../assets/userNew/icon4.png') no-repeat top center;
  background-size: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;

  .main {
    flex: 1;
    display: flex;
    align-items: stretch;
    flex-direction: column;

    .login {
      margin: 60px 0px 0px 24px;
      font-size: 28px;
      color: rgb(6, 18, 30);
      font-weight: bold;
    }

    .login-text {
      color: #707070;
      font-size: 16px;
      margin-left: 24px;
      margin-top: 14px;
      line-height: 20px;
      width: 90%;
    }

    .captcha {
      display: flex;
      justify-content: center;
      margin-top: 40px;
    }

    input {
      margin-right: 20px;
      width: 45px;
      text-align: center;
      border: none;
      border-bottom: 1px solid #212121;
      font-size: 24px;
      outline: none;
      background: none;
    }

    input:last-of-type {
      margin-right: 0;
    }

    input:disabled {
      color: #000;
      background-color: #fff;
    }

    .point {
      flex-direction: row;
      margin-top: 37px;
      justify-content: center;
      display: flex;
      font-size: 17px;
      color: #707070;
      margin-bottom: 36px;

      .once {
        color: #0c62ee;
      }
    }

    .ph-input {
      margin: 40px 24px 20px;
      height: 60px;
      border-bottom: 1px solid #e3e2e2;
      flex-direction: row;
      align-items: center;
      flex-grow: 0;
      display: flex;

      .ph-text {
        color: #06121e;
        width: 50px;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
      }

      .ph-t {
        color: #06121e;
        flex: 1;
        line-height: 50px;
        height: 50px;
        font-size: 17px;
        padding: 0;
        background: none;

        ::v-deep .van-field__left-icon {
          .van-icon {
            font-size: 22px;
          }
        }

        ::v-deep.van-cell__value {
          .van-field__control {
            background: none;
            padding-left: 14px;
            color: #000;
            line-height: 50px;
            height: 50px;
          }
        }
      }

      .ph-t-icon {
        background: url('../../assets/userNew/icon7.png') no-repeat left center;
        background-size: 23px 18px;
        padding-left: 20px;
      }

      .ph-t-icon1 {
        background: url('../../assets/userNew/icon5.png') no-repeat left center;
        background-size: 15px 22px;
        padding-left: 20px;
      }

      .ph-t-icon2 {
        background: url('../../assets/userNew/icon6.png') no-repeat left center;
        background-size: 19px 22px;
        padding-left: 20px;
      }
    }

    .bu_tn {
      width: 230px;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
      color: #3476fe;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }

    .bu_tn-a {
      width: 80%;
      height: 50px;
      line-height: 50px;
      background: linear-gradient(90deg, #50A9FF 0%, #1772FF 100%);
      color: #fff;
      border: 0 !important;
      border-radius: 94px;
      font-size: 16px;
      align-self: center;
      text-align: center;
    }
  }

  .prompt {
    padding: 18px;
    width: 80%;
    background: #fff;
    border-radius: 10px;
    margin: auto;

    .prompt-top {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      padding-left: 22px;
      background: url('../../assets/userNew/icon2.png') no-repeat left center;
      background-size: 17px 12px;
    }

    .prompt-name {
      color: #646668;
      font-size: 12px;
      line-height: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
    }
  }
}
</style>
  
  